<template>
  <div class="main">
    <el-row>
      <el-col :lg="5" :md="6" :sm="7" :xl="4">
        <clouded-glass class="organizationChoose">
          <div class="overflow" slot="content" style="margin: 10px;height: 95%;overflow: auto;">
            <div class="current-location" style="margin-right: 21px;margin-top: 10px;">
              <el-input class="inline-input" v-model="orgName" placeholder="请输入搜索的空间名称" size="mini"
                        @change="changeOrgName"/>
            </div>
            <div style="margin: 20px 10px 10px;">需要授权的组织架构：</div>
            <space-tree-show @spaceChoose="spaceChoose" tree="org" ref="org"
                             style="margin-left: 5px;"></space-tree-show>
          </div>
        </clouded-glass>
      </el-col>
      <el-col :span="24" class="hidden-sm-and-up" style="height: 20px;"></el-col>
      <el-col :lg="19" :md="18" :sm="17" :xl="20">
        <el-row style="padding: 0 10px;">
          <el-row class="button line" style="margin-bottom: 10px!important;">
            <el-button @touchstart="authorizeDevice" @click="authorizeDevice">授权可见设备</el-button>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              :tree-props="{children: 'children'}"
              border
              default-expand-all
              row-key="id"
              class="overflow" style="width: 100%;max-height: 742px; overflow: auto">
              <el-table-column
                header-align="center"
                label="设备"
                prop="name"
                min-width="300"
              >
              </el-table-column>
              <el-table-column
                align="center"
                label="查看权限"
                prop="view"
              >
                <template slot-scope="scope">
                  <i class="el-icon-success" style="color: #00a65a" v-if="scope.row.view"></i>
                  <i class="el-icon-error" style="color: #dd4b39" v-if="scope.row.view === false"></i>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="特殊操控权限"
                prop="controlDetail"
                min-width="200">
                <template slot-scope="scope">
                  <span :key="item.id" style="margin-right: 10px;cursor: default"
                        v-for="item in scope.row.controlDetail">
                    {{ item.name }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-row>
      </el-col>
    </el-row>

    <dialog-component
      :dialogVisible.sync="dialogVisible"
      @dialogClose="(data) => this.dialogVisible = data"
      dialog-title="授权可见设备"
      width="50%">
      <div slot="content" style="padding: 10px 30px;height: 75vh;">
        <el-row style="margin-bottom: 10px;">
          <el-col :span="9">需要授权的组织架构：<span style="color: rgba(7, 230, 248, 1)">{{ this.currentOrg }}</span></el-col>
          <el-col :span="8" style="text-align: right">
            <el-input class="inline-input" v-model="name" placeholder="请输入搜索的名称" size="mini"
                      @change="changeName"></el-input>
          </el-col>
          <el-col :span="7" style="text-align: right">
            <el-button size="mini" @touchstart="updateAuthorizedAllDevice(true)" @click="updateAuthorizedAllDevice(true)">授权所有设备</el-button>
            <el-button size="mini" @touchstart="updateAuthorizedAllDevice(false)" @click="updateAuthorizedAllDevice(false)">取消所有设备授权</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px;">可授权的设备列表：<span
          style="color: #ccc;font-size: 0.8rem">(点击操作后数据将实时保存)</span>
        </el-row>
        <el-row class="overflow" style="overflow-y: auto;max-height: 620px;">
          <el-table
            :data="authoData"
            :tree-props="{children: 'children'}"
            border
            default-expand-all
            row-key="id"
            class="overflow" style="width: 100%; overflow: auto;">
            <el-table-column
              header-align="center"
              label="设备"
              prop="name"
              min-width="300"
              sortable>
            </el-table-column>
            <el-table-column
              align="center"
              label="查看权限"
              prop="view"
              sortable>
              <template slot-scope="scope">
                <el-checkbox @change="(value) => checkClick(value,scope.row,null)" v-if="scope.row.view !== null"
                             v-model="scope.row.view"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="特殊操控权限"
              min-width="200"
              prop="controlDetail">
              <template slot-scope="scope">
                <div v-if="scope.row.modelControls">
                  <span :key="item.id" v-for="item in scope.row.modelControls">
                    <el-checkbox
                      :disabled="!scope.row.view"
                      v-loading="isLoad"
                      :checked="scope.row.controlDetail ? (exitControl(scope.row.controlDetail,item.id) ? 'checked' : false) : false"
                      @change="(value) => checkClick(value,scope.row,item)">{{ item.name }}
                    </el-checkbox>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </dialog-component>

  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import DialogComponent from "@/components/DialogComponent";
import {authorizedDevice, listByOrgId, updateAuthorizedAllDevice} from "@/network/device-info";

export default {
  name: "DeviceAuthority",
  components: {CloudedGlass, SpaceTreeShow, DialogComponent},
  inject: ['overflow'],
  mounted() {
    this.overflow()
  },
  data() {
    return {
      orgName:'',
      tableData: [],
      authoData: [],
      iniTableData: [],
      currentOrg: null,
      dialogVisible: false,
      id: null,
      isLoad: false,
      name: ''
    }
  },
  computed: {
    exitControl() {
      return function (controlDetail, id) {
        const detailIds = controlDetail.map(item => {
          return item.id
        })
        return detailIds.indexOf(id) > -1;
      }
    }
  },
  methods: {
    listByOrgId() {
      listByOrgId(this.id).then(res => {
        this.isLoad = false
        this.tableData = res.data
        this.iniTableData = this.authoData = this.tableData
        this.changeName()
      }).catch(e => {
        this.isLoad = false
        console.log(e, "发生异常")
      })
    },
    spaceChoose(data) {
      this.id = data.id;
      this.currentOrg = data.title;
      this.listByOrgId();
    },
    authorizeDevice() {
      this.dialogVisible = true;
      this.tableData = []
      this.iniTableData = this.authoData = this.tableData
      this.listByOrgId();
      this.name=""
    },
    // 树形筛选
    changeOrgName(){
      this.$refs.org.changName(this.orgName);
    },
    checkClick(value, row, control) {
      // let i = 1
      // if (i == 1) {
      //   return;
      // }
      const controlDetail = row.controlDetail ? row.controlDetail : []
      if (control) {
        if (value) {
          controlDetail.push(control)
        } else {
          const index = controlDetail.findIndex(item => {
            if (item.id == control.id) {
              return true;
            }
          })
          controlDetail.splice(index, 1)
        }
      }
      const spacePermission = row.spacePermission;
      spacePermission.orgId = this.id;
      spacePermission.isView = row.view;
      spacePermission.deviceId = row.id;
      spacePermission.controlDetail = controlDetail.length > 0 ? JSON.stringify(controlDetail) : "";
      spacePermission.type = 1;
      // spacePermission.id=
      this.isLoad = true
      authorizedDevice(spacePermission).then(() => {
        this.listByOrgId();
      }).catch(e => {
        this.isLoad = false
        console.log(e, "发生异常")
      })
    },
    updateAuthorizedAllDevice(isView) {
      if (this.tableData.length <= 0) {
        this.$message.error('无可操作空间！')
        return
      }
      let text = isView ? '授权所有空间(包含未筛选空间）' : '取消所有空间授权（包含未筛选空间）'
      this.$confirm('是否' + text, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: "msgbox",
        callback: action => {
          if (action === 'confirm') {
            updateAuthorizedAllDevice(this.id, isView).then(res => {
              this.isLoad = false
              console.log(res)
              this.listByOrgId()
            }).catch(e => {
              this.isLoad = false
              console.log(e, "发生异常")
            })
          }
        }
      })
    },
    // 筛选
    changeName() {
      if (!this.name) {
        this.authoData = this.iniTableData
        return
      }
      let arr = JSON.parse(JSON.stringify(this.iniTableData))
      let newA = []
      arr.forEach((item,ind) => {
        console.log(item)
        newA[ind] = item
        if(newA[ind].name.indexOf(this.name) == '-1'){
          newA[ind].children = item.children?item.children.filter(val => val.name.indexOf(this.name) != '-1'): []
        }else{
          newA[ind].children = item.children
        }
      })
      for(let i=newA.length; i--; i>0 ) {
        if(!newA[i].children || newA[i].children.length == 0) {
          if(newA[i].name.indexOf(this.name) == '-1'){
            newA.splice(i,1)
          }
        }
      }
      this.authoData = newA
    }
  }
}
</script>

<style scoped>
.main {
  padding: 20px 20px 0 20px;
}

.organizationChoose {
  width: 100%;
  overflow: auto;
  height: calc(100vh - 125px);
}

@media (max-width: 767px) {
  .organizationChoose {
    width: 100%;
    height: auto;
  }
}

.el-checkbox {
  color: #fff
}
</style>
